import { z } from "zod";
import { Holding } from "../holdings/holding.js";

export const Ok = Holding.array();
export const Err = z.string();
